import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const addKYC = async(
  userid, 
  doctype, 
  imagedata, 
  ext, 
  countryName, 
  docname, 
  docnum, 
  issuingCountry, 
  docdate, 
  docState, 
  issuingDate,
  PIN,
  agentID,
  profileStatus,
  kycTypeToSend
) => {
    try {
        const data = JSON.stringify({
          svc: "KYC_legacy",
          pid: "updateKYC",
          dat: {
            userid: userid,
            doctype: doctype,
            imagedata: imagedata,
            extension: ext,
            countryName: countryName,
            docname: docname,
            docnum: docnum,
            issuingCountry: issuingCountry,
            docdate: docdate,
            docState: docState,
            issuingDate: issuingDate,
            pin: PIN,
            agentID: agentID,
            profileStatus:profileStatus,
            kycType:kycTypeToSend
          },
        });
    
        const config = {
          method: "post",
          url: BACKEND_URL,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
    
        const response = await axios(config);
        return response.data;
      } catch (error) {
        console.log(error);
      }
}

export const getKYCNCS = async(userid, docs) => {
  try {
      const data = JSON.stringify({
        svc: "KYC_legacy",
        pid: "getKYCDoc",
        dat: {
          userid: userid,
          docs: docs
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
}

export const getSingleKYCDoc = async(userid, docid) => {
  try {
      const data = JSON.stringify({
        svc: "KYC_legacy",
        pid: "getSingleKYCDoc",
        dat: {
          userid: userid,
          docid: docid
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
}

export const updateProfile = async(userid, element, docstring, state) => {
  try {
      const data = JSON.stringify({
        svc: "KYC_legacy",
        pid: "UpdateConsumerProfile",
        dat: {
          userid: userid,
          profilestatus: state === 2 ? 4 : 0, //if accepted set state to 4, otherwise 0
          element: element, //other field such as other1, other2 etc
          docstring: docstring, //looks like 4843-AD4XRDBBR3-1-2586
          state: state //pending (1), accept(2), reject(3)
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
}

export const updateProfileKYC = async(userid, element, docstring, profilestatus, state) => {
// export const updateProfileKYC = async(userid, element, docstring, state) => {
  try {
      const data = JSON.stringify({
        svc: "KYC_legacy",
        pid: "UpdateConsumerProfile",
        dat: {
          userid: userid,
          profilestatus: profilestatus, //if accepted set state to 4, otherwise 0
          element: element, //other field such as other1, other2 etc
          docstring: docstring, //looks like 4843-AD4XRDBBR3-1-2586
          state: state //pending (1), accept(2), reject(3)
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
}

export const OFACRead = async(userid) => {
  try {
      const data = JSON.stringify({
        svc: "ofac",
        pid: "OFACRead",
        dat: {
          userid: userid,
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
}
export const ofacCheck = async(
  firstName, 
  lastName, 
  dob, 
  gender,
  citizenship,
  type,
  kycuser,
) => {
  try {
      const data = JSON.stringify({
        svc: "ofac",
        pid: "OFACCheck",
        dat: {
          firstName: firstName,
          lastName: lastName,
          dob: dob,
          gender: gender,
          citizenship: citizenship,
          type: type,
          kycuser: kycuser
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
}

export const addRejectionNotes = async(userid, agentID, note) => {
  try {
      const data = JSON.stringify({
        svc: "KYC_legacy",
        pid: "UserNotesAdd",
        dat: {
          userid: userid,
          agentID: agentID,
          note: note
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
    
}

export const getNotes = async(userid) => {
  try {
      const data = JSON.stringify({
        svc: "KYC_legacy",
        pid: "UserNotesList",
        dat: {
          userid: userid,
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
    
}

export const updateKYCInfo = async(
  userid,
  extractedData, 
  imagedata, 
  ext,
  agentID,
  PIN,
  documentname
) => {
    try {
        const data = JSON.stringify({
          svc: "KYC_legacy",
          pid: "UpdateKycInfo",
          dat: {
            userid: userid,
            ...extractedData,
            imagedata: imagedata,
            extension: ext,
            agentID: agentID,
            pin: PIN,
            documentname: documentname
          },
        });
    
        const config = {
          method: "post",
          url: BACKEND_URL,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
    
        const response = await axios(config);
        return response.data;
      } catch (error) {
        console.log(error);
      }
}

export const getKYCTypes = async() => {
    try {
        const data = JSON.stringify({
          svc: "KYC_legacy",
          pid: "getKYCTypes",
          dat: {},
        });
    
        const config = {
          method: "post",
          url: BACKEND_URL,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
    
        const response = await axios(config);
        return response.data;
      } catch (error) {
        console.log(error);
      }
}
